/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import * as queryString from 'query-string';
import { PricingItemResponse } from '../api/pricingAPI';

export const getQueryString = (parameters: { [key: string]: string | number }): string => {
  const queryFilterParameters: { [key: string]: string } = {};
  Object.entries(parameters).forEach(([key, value]: any) => {
    queryFilterParameters[key] =
      value.value !== undefined
        ? // eslint-disable-next-line
          value.value.toString().replace(/[^\x00-\x7F]/g, '')
        : undefined;
  });
  return queryString.stringify(queryFilterParameters);
};

export function isNumeric(n: any): n is number | string {
  return !isNaN(parseFloat(n)) && isFinite(n) && !n.toString().match(/[Ee,]/g);
}

export function replaceLocale(str: string, language: string, country: string): string {
  let result = str;
  result = result.replace('###LANGUAGE###', language);
  result = result.replace('###COUNTRY###', country);
  return result;
}

export const getSalesOrgMap = (countryCode: string) => {
  const salesOrgMap = new Map<string, string>([
    ['hq', '0001'],
    ['nl', '0100'],
    ['dk', '0110'],
    ['se', '0120'],
    ['es', '0130'],
    ['fr', '0140'],
    ['be', '0150'],
    ['no', '0160'],
    ['za', '0170'],
    ['fi', '0180'],
    ['ie', '0190'],
    ['de', '0002'],
    ['us', '0200'],
    ['ca', '0210'],
    ['br', '0220'],
    ['mx', '0230'],
    ['ar', '0240'],
    ['co', '0260'],
    ['cl', '0280'],
    ['pe', '0290'],
    ['au', '0300'],
    ['nz', '0301'],
    ['jp', '0310'],
    ['id', '0320'],
    ['sg', '0330'],
    ['vn', '0335'],
    ['ph', '0340'],
    ['kr', '0360'],
    ['my', '0370'],
    ['hk', '0380'],
    ['cn', '0400'],
    ['tw', '0420'],
    ['in', '0430'],
    ['th', '0440'],
    ['pl', '0500'],
    ['cz', '0510'],
    ['hu', '0525'],
    ['bg', '0535'],
    ['sk', '0540'],
    ['ro', '0550'],
    ['ua', '0570'],
    ['hr', '0580'],
    ['si', '0590'],
    ['at', '0060'],
    ['tr', '0620'],
    ['gr', '0630'],
    ['lt', '0660'],
    ['lv', '0670'],
    ['il', '0680'],
    ['pt', '0690'],
    ['ch', '0070'],
    ['ae', '0760'],
    ['rs', '0780'],
    ['gb', '0080'],
    ['it', '0090'],
  ]);
  return salesOrgMap.get(countryCode.toLowerCase());
};

export const getCompanyIdFromFWALayer = () => {
  const fwaLayer = window.fwaLayer;
  if (fwaLayer) {
    return fwaLayer.user.companyId;
  }
};

export const getDealerRightsValue = () => {
  const fwaLayer = window.fwaLayer;
  if (fwaLayer) {
    return fwaLayer.user.hasDealerRights;
  }
};

export function getTotalNumericPrice(prices: PricingItemResponse[] | null): number {
  if (prices && prices.length > 0) {
    return prices.reduce((accumulator: number, price: PricingItemResponse) => {
      return accumulator + price.net;
    }, 0);
  }
  return 0;
}

export function getSolutionPrice(prices: PricingItemResponse[] | null): string {
  let solutionPrice = 0;
  let currency = '';

  if (prices && prices.length > 0) {
    solutionPrice = getTotalNumericPrice(prices);
    currency = prices[0].currency.toUpperCase();
  }

  return `${solutionPrice.toFixed(2)} ${currency}`;
}

export const getFormattedDate = () => {
  const now = new Date();
  return (
    new Intl.DateTimeFormat('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
      .format(now)
      .replace(',', '')
      // Replace / and : for -
      .replace(/[/:]/g, '-')
  );
};
